




import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import BaseComponent from '@/components/base-component.vue';
import { cepFormat } from '@/helpers/cepFormat';

@Component
export default class UiCepFormat extends BaseComponent {
  @Prop()
  public cep: string;

  public cepFormated: string = '';

  @Watch('cep')
  public onChangeCep(val: string): void {
    this.cepFormated = cepFormat(val);
  }

  public beforeMount(): void {
    this.cepFormated = cepFormat(this.cep);
  }
}
